import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Menu, X } from 'lucide-react';
import logoWhite from '@/assets/logo-refify-white.webp';

interface LandingHeaderProps {
  scrollToSection: (id: string) => void;
}

export function LandingHeader({ scrollToSection }: LandingHeaderProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleScroll = (id: string) => {
    scrollToSection(id);
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 w-full z-50 bg-landing-deep">
      {/* Thin accent line at top */}
      <div className="h-1 w-full bg-landing-line" />

      <div className="container mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/">
          <img src={logoWhite} alt="Refify logo" width={200} height={86} className="h-7 w-auto object-contain" />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          <button
            onClick={() => handleScroll('features')}
            className="text-base font-medium text-[#f0ebe0] hover:text-white transition-colors"
          >
            Features
          </button>
          <Link
            to="/reference-styles"
            className="text-base font-medium text-[#f0ebe0] hover:text-white transition-colors"
          >
            Reference styles
          </Link>
          <Link
            to="/pricing"
            className="text-base font-medium text-[#f0ebe0] hover:text-white transition-colors"
          >
            Pricing
          </Link>
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <Link to="/auth">
            <Button
              variant="ghost"
              className="hover:bg-white/10 text-base font-medium text-[#f0ebe0]"
            >
              Sign in
            </Button>
          </Link>
          <Link to="/auth">
            <Button
              size="sm"
              className="rounded-full px-5 font-medium bg-landing-line text-white hover:bg-landing-line/90"
            >
              Get Started
            </Button>
          </Link>
        </div>

        {/* Mobile menu button */}
        <button className="md:hidden p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Open menu">
          {mobileMenuOpen ? <X className="w-6 h-6 text-[#d4ddd8]" /> : <Menu className="w-6 h-6 text-[#d4ddd8]" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="bg-landing-deep border-t border-white/15">
          <div className="container mx-auto px-6 py-4 flex flex-col gap-4">
            <button onClick={() => handleScroll('features')} className="text-left py-2 text-base font-medium text-[#f0ebe0]">
              Features
            </button>
            <Link to="/reference-styles" onClick={() => setMobileMenuOpen(false)} className="text-left py-2 text-base font-medium text-[#f0ebe0]">
              Reference styles
            </Link>
            <Link to="/pricing" onClick={() => setMobileMenuOpen(false)} className="text-left py-2 text-base font-medium text-[#f0ebe0]">
              Pricing
            </Link>
            <div className="flex flex-col gap-2 pt-4 border-t border-white/15">
              <Link to="/auth">
                <Button variant="ghost" className="w-full justify-center text-base font-medium text-[#f0ebe0]">Sign in</Button>
              </Link>
              <Link to="/auth">
                <Button className="w-full justify-center rounded-full bg-landing-line text-white hover:bg-landing-line/90">Get Started</Button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
